module.exports = __webpack_public_path__ + "img/logo.5645f18d.png";